import React from "react";
import Constant from "../utils/constant";
import MWebHeaderBody from "./MwebHeader";
import WebHeaderBody from "./WebHeader";
import WebFooterBody from "./WebFooter";
function layoutWithConstant(props, WrapperComponent) {
    const { isUat, isDev, cookies, runtime } = props;
    Constant.isDev = !!isDev;
    Constant.isUat = isUat ? true : false;
    Constant.sessionKey = cookies["sessionKey"] || "";
    Constant.isLogin = !!cookies["sessionKey"];
    Constant.sid = runtime.sid || "0";
    Constant.country = runtime.countryCode || "USA";
    Constant.countryCode2 = runtime.countryCode2 || "US";
    Constant.language = runtime.languageCode || "en";
    Constant.currency = runtime.currency || "USD";
    Constant.platform = runtime.platform;
    Constant.countryId = runtime.countryId || "223";
    const { children } = props;
    return (React.createElement(React.Fragment, null,
        React.createElement(WrapperComponent, Object.assign({}, props)),
        children));
}
export const MWebHeader = (props) => {
    return layoutWithConstant(props, MWebHeaderBody);
};
export const WebHeader = (props) => {
    return layoutWithConstant(props, WebHeaderBody);
};
export const WebFooter = (props) => {
    return layoutWithConstant(props, WebFooterBody);
};
